/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../../../components/Modal';
import OptionsScreen from './OptionsScreen';
import { SendCryptoScreensFlow } from '../../constants';
import ConfirmTransaction from './ConfirmTransaction';
import VerifyTransaction from './VerifyTransaction';
import SendCryptoWhitelist from './SendCyptoWhitelist';
import SendCrypto from './SendCrypto';
import LedgerWalletsWhitelist from './LedgerWalletsWhitelist';
import WhitelistVerify from './WhitelistVerify';
import WhitelistSelectAddress from './WhitelistSelectAddress';
import WhitelistManageAddresses from './WhitelistManageAddresses';
import WhitelistDeleteAddress from './WhitelistDeleteAddress';
import WhitelistChangeLedgerWallet from './WhitelistChangeLedgerWallet';
import WhitelistAddExternal from './WhitelistAddExternal';
import { useSetting } from '../../../../utilities/sharedHooks/settings';
import ConfirmNewAmountTransaction from './ConfirmNewAmountTransaction';

const SendCryptoModal = ({
  hide,
  wallet,
  wallets,
  onChangeWallet,
  ledgerAccount,
  fiatCurrencyCode,
  onSent,
  initialScreen,
}) => {
  const { t: translate } = useTranslation();
  const [currentScreen, setCurrentScreen] = useState(initialScreen);
  const [currentOptions, setCurrentOptions] = useState({
    [initialScreen]: { wallet, ledgerAccount },
  });

  const [isWhitelistFunctionalityEnabled] = useSetting(
    'app_features',
    'feature_toggle_ledger_whitelist_functionality'
  );

  const sendCryptoFlow = useMemo(
    () => [
      {
        screen: SendCryptoScreensFlow.SEND_CRYPTO,
        component: isWhitelistFunctionalityEnabled ? (
          <SendCryptoWhitelist
            wallet={wallet}
            fiatCurrencyCode={fiatCurrencyCode}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.SEND_CRYPTO]}
          />
        ) : (
          <SendCrypto
            wallet={wallet}
            fiatCurrencyCode={fiatCurrencyCode}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.SEND_CRYPTO]}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_ADDRESS_TYPE,
        component: (
          <OptionsScreen
            isSendCryptoFlow
            wallet={wallet}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_ADDRESS_TYPE]}
            types={[
              {
                title: translate('whitelist_add_address_ledger').replace(
                  '%s',
                  wallet?.coin.toUpperCase()
                ),
                onClick: () => {
                  setCurrentScreen(SendCryptoScreensFlow.WHITELIST_WALLET_ADDRESS_LEDGER);
                  setCurrentOptions({
                    ...currentOptions,
                    [SendCryptoScreensFlow.WHITELIST_WALLET_ADDRESS_LEDGER]: {
                      prevScreen: SendCryptoScreensFlow.WHITELIST_ADDRESS_TYPE,
                    },
                  });
                },
              },
              {
                title: translate('whitelist_add_address_external').replace(
                  '%s',
                  wallet?.coin.toUpperCase()
                ),
                onClick: () => {
                  setCurrentScreen(SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL);
                  setCurrentOptions({
                    ...currentOptions,
                    [SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL]: {
                      prevScreen: SendCryptoScreensFlow.WHITELIST_ADDRESS_TYPE,
                    },
                  });
                },
              },
            ]}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_WALLET_ADDRESS_LEDGER,
        component: (
          <LedgerWalletsWhitelist
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            wallet={wallet}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_VERIFY,
        component: (
          <WhitelistVerify
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            wallet={wallet}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_VERIFY]}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_SELECT_ADDRESS,
        component: (
          <WhitelistSelectAddress
            wallet={wallet}
            fiatCurrencyCode={fiatCurrencyCode}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_SELECT_ADDRESS]}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES,
        component: (
          <WhitelistManageAddresses
            wallet={wallet}
            fiatCurrencyCode={fiatCurrencyCode}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_MANAGE_ADDRESSES]}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_DELETE_ADDRESS,
        component: (
          <WhitelistDeleteAddress
            wallet={wallet}
            fiatCurrencyCode={fiatCurrencyCode}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_DELETE_ADDRESS]}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_CHANGE_WALLET,
        component: (
          <WhitelistChangeLedgerWallet
            wallet={wallet}
            wallets={wallets}
            fiatCurrencyCode={fiatCurrencyCode}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_CHANGE_WALLET]}
            onChangeWallet={onChangeWallet}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL,
        component: (
          <WhitelistAddExternal
            isSendCryptoFlow
            wallet={wallet}
            fiatCurrencyCode={fiatCurrencyCode}
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            ledgerAccount={ledgerAccount}
            options={currentOptions[SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL]}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.CONFIRM_TRANSACTION,
        component: (
          <ConfirmTransaction
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            onCloseModal={hide}
            onSent={onSent}
            options={currentOptions[SendCryptoScreensFlow.CONFIRM_TRANSACTION]}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.VERIFY_TRANSACTION,
        component: (
          <VerifyTransaction
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            onCloseModal={hide}
            onSent={onSent}
            options={currentOptions[SendCryptoScreensFlow.VERIFY_TRANSACTION]}
          />
        ),
      },
      {
        screen: SendCryptoScreensFlow.CONFIRM_NEW_AMOUNT_TRANSACTION,
        component: (
          <ConfirmNewAmountTransaction
            openScreen={(screenName, options) => {
              setCurrentOptions({ ...currentOptions, [screenName]: options });
              setCurrentScreen(screenName);
            }}
            onCloseModal={hide}
            onSent={onSent}
            options={currentOptions[SendCryptoScreensFlow.CONFIRM_NEW_AMOUNT_TRANSACTION]}
          />
        ),
      },
    ],
    [wallet, fiatCurrencyCode, ledgerAccount, currentOptions, hide]
  );

  const selectedComponent = useMemo(
    () => sendCryptoFlow.find((item) => item.screen === currentScreen).component,
    [currentScreen, sendCryptoFlow]
  );

  return (
    <ModalRoot>
      <Modal>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{selectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};
export default SendCryptoModal;
SendCryptoModal.propTypes = {
  hide: PropTypes.func.isRequired,
  wallet: PropTypes.object.isRequired,
  fiatCurrencyCode: PropTypes.string.isRequired,
  ledgerAccount: PropTypes.object,
  onSent: PropTypes.func,
  onChangeWallet: PropTypes.func,
  wallets: PropTypes.any,
  initialScreen: PropTypes.string,
};
SendCryptoModal.defaultProps = {
  ledgerAccount: null,
  onSent: () => {},
  onChangeWallet: () => {},
  initialScreen: SendCryptoScreensFlow.SEND_CRYPTO,
};
